import { render, staticRenderFns } from "./DeviceLicensesTable.vue?vue&type=template&id=665403d2"
import script from "./DeviceLicensesTable.vue?vue&type=script&lang=js"
export * from "./DeviceLicensesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports